import { i18n } from "@/plugins/i18n"
import portalPartners from "@/routes/portal/portalPartners";
import portalSettings from "@/routes/portal/portalSettings";

export default [
  {
    path: "/portal",
    component: () => import("@/layouts/main/Portal"),
    meta: {
      pageTitle: "Portal",
      rule: "portalAdmin",
    },
    children: [
      {
        path: "/",
        name: "portal.dashboard",
        component: () => import("@/views/Portal/Dashboard"),
        meta: {
          pageTitle: i18n.t("route.page_title.portal.dashboard"),
          rule: "portalAdmin",
        },
      },
      {
        path: "accounts",
        name: "portal.accounts",
        component: () => import("@/views/Portal/PortalAccounts/PortalAccounts"),
        meta: {
          pageTitle: i18n.t("route.page_title.portal.accounts"),
          rule: "portalAdmin",
        },
      },
      {
        path: "stations",
        name: "portal.stations",
        component: () => import("@/views/Portal/PortalStations/PortalStations"),
        meta: {
          pageTitle: i18n.t("route.page_title.portal.stations"),
          rule: "portalAdmin",
        },
      },
      {
        path: "people",
        name: "portal.people",
        component: () => import("@/views/Portal/PortalPeople"),
        meta: {
          pageTitle: i18n.t("route.page_title.portal.people"),
          rule: "portalAdmin",
        },
      },
      ...portalSettings,
      ...portalPartners,
    ],
  },
];
